import { DistributionChannel } from './distribution-channel';
import { PartnerCostTransferType } from './product';

export interface VoucherData {
    claimedOn: number;
    claimedInPtg?: boolean;
    clientId: string;
    comments: string;
    createdOn: number;
    email: string;
    isFreeTicket: boolean;
    key: string;
    paymentId: string;
    price: number;
    partnerCost: number;
    partnerCostTransferType: PartnerCostTransferType;
    productKey: string;
    redeemedOn: number;
    userKey: string;
    distributionChannel: DistributionChannel;
}
